<template lang="html">

  <div class="idioma">
    <span>Idiomas:</span>
    <button @click="requestLangChange('es')" :active="lang == 'es'">Español</button>
    <span class="separator">/</span>
    <button @click="requestLangChange('en')" :active="lang == 'en'">Inglés</button>
  </div>

</template>

<script lang="js">

  import {mapGetters,mapActions} from 'vuex';

  export default  {
    name: 'idioma',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {
      ...mapActions(['changeLanguage']),
      requestLangChange : function(requestedLang){
        console.log(requestedLang);
        this.changeLanguage(requestedLang)
        .then(r => {
          this.$i18n.locale = r;
          // this.changePath(); 
        }).catch(e =>{
          console.log(e);
        })
      },
    },
    computed: {
      ...mapGetters({
        lang : 'getLanguage'
      })
    }
  }
</script>

<style scoped lang="scss">
*{
  background: none;
  border: none;
  outline: none;
  color: white;
  color: #fff;
  font-family: 'philosopherregular';
  font-size: 16px;
  cursor: pointer;
}

button[active="true"]{
  text-decoration: underline;
}

button:first-of-type{
  padding-right: 5px;
}
.separator{
  margin-right: 5px;
}


</style>



// WEBPACK FOOTER //
// src/components/view-parts/footer/idioma.vue